import { useState } from "react";
import { toast } from "sonner";
import { useGet } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { c$ } from "@/lib/tips";
import { Button } from "@/components/ui/button";
import { Pill } from "@/components/app/Bits";

export function RevisionHistory({ items }) {
  if (!items?.length) return null;
  return (
    <div className="rounded-lg border divide-y text-sm" data-testid="revision-history"><div className="p-2 font-medium">Revisions</div>
      {items.map((r) => <div key={r.revision} className="p-2 text-xs" data-testid={`revision-${r.revision}`}>Revision {r.revision}: {c$(r.previous_cents)} → {c$(r.revised_cents)} (<b>{r.difference_cents >= 0 ? "+" : ""}{c$(r.difference_cents)}</b>) · “{r.reason}” · approved by {r.approved_by}</div>)}
    </div>
  );
}

export function CorrectionRequest({ shiftId }) {
  const { data, refetch } = useGet("/me/tip-corrections");
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const mine = (data?.items || []).filter((r) => r.shift_id === shiftId);
  const active = mine.find((r) => ["open", "approved"].includes(r.status));
  const send = async () => {
    try { await api.post("/me/tip-corrections", { shift_id: shiftId, message: msg }); toast.success("Sent to management"); setOpen(false); setMsg(""); refetch(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2 print:hidden" data-testid="correction-request">
      {mine.map((r) => <div key={r.id} className="rounded-lg bg-[#FBF9F5] p-2 text-xs" data-testid={`my-correction-${r.id}`}><Pill tone={r.status === "declined" ? "red" : r.status === "resolved" ? "green" : "amber"}>{r.status}</Pill> “{r.message}”{r.response ? ` — ${r.responded_by}: ${r.response}` : ""}</div>)}
      {!active && (open ? <div className="space-y-2"><textarea className="w-full rounded-lg border p-2 text-sm" rows={3} value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="What looks wrong? (for example: I worked 6 hours, not 5)" data-testid="correction-message" />
        <div className="flex gap-2"><Button className="h-10" disabled={msg.trim().length < 5} onClick={send} data-testid="correction-send">Send request</Button><Button variant="outline" className="h-10" onClick={() => setOpen(false)}>Cancel</Button></div></div>
        : <Button variant="outline" className="h-10 w-full" onClick={() => setOpen(true)} data-testid="correction-open">Request a correction</Button>)}
    </div>
  );
}
